import { billingCopayBaseModel } from './crud';

export * from './types';
export const billingCopayModelKeys = billingCopayBaseModel.keys;

export const useBillingCopayById = billingCopayBaseModel.fetchById();
export const useBillingCopayByIds = billingCopayBaseModel.fetchByIds();
export const useBillingCopayMany = billingCopayBaseModel.fetchMany();
export const useBillingCopayCount = billingCopayBaseModel.count();
export const useBillingCopayManyInfiniteQuery =
  billingCopayBaseModel.fetchPaginated();
export const useBillingCopayUpdateOne = billingCopayBaseModel.edit();
export const useBillingCopayCreateOne = billingCopayBaseModel.create();
export const useBillingCopayRemoveOne = billingCopayBaseModel.delete();
export const useBillingCopayRemoveByIds = billingCopayBaseModel.deleteByIds();

export const useBillingCopayByIdV2 = billingCopayBaseModel.fetchByIdV2();
export const useBillingCopayByIdsV2 = billingCopayBaseModel.fetchByIdsV2();
export const useBillingCopayManyV2 = billingCopayBaseModel.fetchManyV2();
export const useBillingCopayCountV2 = billingCopayBaseModel.countV2();
export const useBillingCopayManyInfiniteQueryV2 =
  billingCopayBaseModel.fetchPaginatedV2();
export const useBillingCopayUpdateOneV2 = billingCopayBaseModel.editV2();
export const useBillingCopayCreateOneV2 = billingCopayBaseModel.createV2();
export const useBillingCopayRemoveOneV2 = billingCopayBaseModel.deleteV2();
export const useBillingCopayRemoveByIdsV2 =
  billingCopayBaseModel.deleteByIdsV2();

export const useBillingCopayPagination = billingCopayBaseModel.fetchPaginated();
export const useBillingCopayPaginationV2 =
  billingCopayBaseModel.fetchPaginatedV2();
